// extracted by mini-css-extract-plugin
module.exports = {"loading":"FormSubmitButton_loading__SpIft"};